import { api } from './index';

const ResalesRequestService = {
    getAll: async(params) => {
        return await api.get('company-request',params);
    },
    getByManufacturer: async(id) => {
        return await api.get('company-request/by-manufacturer/'+id);
    },
    getAllExport: async(params) => {
        return await api.get('company-request-export',params);
    },
    getResale: async(id) => {
        return await api.get('company-request/'+id);
    },
    saveResale: async(id,form) => {
        return await api.put('company-request/'+id,form);
    },
    getInfoResale: async() => {
        return await api.get('company-request/info-form');
    },
    getResaleContacts: async(id) => {
        return await api.get('company-request/contacts/'+id);
    },
    updateResaleContacts: async(id,form) => {
        return await api.put('company-request/contacts/'+id,form);
    },
    getResaleBUs: async(id) => {
        return await api.get('company-request/bus/'+id);
    },
    updateResaleBUs: async(id,form) => {
        return await api.put('company-request/bus/'+id,form);
    },
    getResaleAttendance: async(id,params) => {
        return await api.get('company-request/attendance/'+id,params);
    },
    getResaleBrands: async(id,params) => {
        return await api.get('company-request/brands/'+id,params);
    },
    getResaleLeadHistory: async(id,params) => {
        return await api.get('company-request/lead-history/'+id,params);
    },
    updateReceiveLead: async(id, receive_lead) => {
        return await api.put('company-request/update-receive-lead/'+id, {receive_lead});
    },

};

export default ResalesRequestService;